<template>
  <div>
    <div :class='[{ "is-active": isOpen }, "modal"]'>
      <div class='modal-background'></div>

      <div class='modal-card'>
        <header class='modal-card-head'>
          <h2 class='modal-card-title'>Blocked Recipient</h2>
          <button class='delete' aria-label='close' @click='onClose'></button>
        </header>

        <section class='modal-card-body'>
          <ErrorNotification
            v-if='errors.length'
            :messages='errors'
            @clear='$emit("clearErrors")'
          />

          <div class='field'>
            <label class='label'>Domain</label>
            <div class='control'>
              <input
                readonly
                class='input'
                type='text'
                :value='recipient.domain'
              />
            </div>
          </div>

          <div class='field'>
            <label class='label'>Created By</label>
            <div class='control'>
              <input
                readonly
                class='input'
                type='text'
                :value='recipient.createdBy'
              />
            </div>
          </div>

          <div class='field'>
            <label class='label'>Created At</label>
            <div class='control'>
              <input
                readonly
                class='input'
                type='text'
                :value='$filters.formatDate(recipient.createdAt)'
              />
            </div>
          </div>

          <div class='field'>
            <label class='label'>Type of block</label>
            <div class='select'>
              <select disabled aria-readonly="true" readonly :value='recipient.blockType'>
                <option selected value='domainOnly'>Exactly this domain</option>
                <option value='subdomainOnly'>Only subdomains of this domain</option>
                <option value='domainAndSubdomains'>This domain and all subdomains</option>
              </select>
            </div>
          </div>

          <div class='field'>
            <label class='label'>Comment</label>
            <div class='control'>
              <textarea
                readonly
                class='input'
                :value='recipient.comment'
              />
            </div>
          </div>
        </section>

        <footer class='modal-card-foot'>
          <div style='width: 100%'>
            <button
              v-if='isAdmin'
              class='button is-danger is-outlined'
              @click='isConfirmDeleteOpen = true'
            >
              Delete
            </button>
            <button
              class='button is-cancel is-pulled-right'
              @click='$emit("close")'
            >
              Close
            </button>
          </div>
        </footer>

        <DeleteConfirmation
          :isOpen='isConfirmDeleteOpen'
          @confirm='onConfirmDelete'
          @cancel='isConfirmDeleteOpen = false'
        >
          <p>Are you sure you want to delete this Blocked Recipient?</p>
        </DeleteConfirmation>
      </div>
    </div>
  </div>
</template>

<script>
import DeleteConfirmation from '@/components/DeleteConfirmation.vue';
import ErrorNotification from '@/components/ErrorNotification.vue';

export default {
  name: 'BlockedRecipientDetails',

  components: {
    DeleteConfirmation,
    ErrorNotification
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    recipient: {
      type: Object,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      isConfirmDeleteOpen: false
    }
  },

  mounted() {
    document.body.addEventListener('keydown', this.onKeydown);
  },

  unmounted() {
    document.body.removeEventListener('keydown', this.onKeydown);
  },

  methods: {
    onKeydown(e) {
      if (!this.isOpen) return;

      if (e.which === 27) {
        this.onClose();
      }
    },

    onClose() {
      this.$emit('close');
    },

    onConfirmDelete() {
      this.$emit('delete', this.recipient.domain);
      this.isConfirmDeleteOpen = false;
    }
  }
}
</script>
